import React from 'react';
import { 
  Dialog, DialogTitle, DialogContent, DialogActions, 
  Button, TextField
} from '@mui/material';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

const ThemeSchema = Yup.object().shape({
  title: Yup.string().required('Title is required'),
  description: Yup.string()
});

export default function ThemeFormDialog({ open, theme, onClose, onSubmit }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Formik
        initialValues={{
          title: theme?.title || '',
          description: theme?.description || '',
        }}
        validationSchema={ThemeSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting, errors, touched }) => (
          <Form>
            <DialogTitle>
              {theme ? 'Edit Theme' : 'Add New Theme'}
            </DialogTitle>
            <DialogContent>
              <Field name="title">
                {({ field }) => (
                  <TextField
                    {...field}
                    margin="normal"
                    label="Title"
                    fullWidth
                    error={touched.title && Boolean(errors.title)}
                    helperText={touched.title && errors.title}
                  />
                )}
              </Field>
              
              <Field name="description">
                {({ field }) => (
                  <TextField
                    {...field}
                    margin="normal"
                    label="Description"
                    fullWidth
                    multiline
                    rows={3}
                    error={touched.description && Boolean(errors.description)}
                    helperText={touched.description && errors.description}
                  />
                )}
              </Field>
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose}>Cancel</Button>
              <Button type="submit" variant="contained" disabled={isSubmitting}>
                {isSubmitting ? 'Saving...' : 'Save'}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}
